import React, { useState } from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";
import { Button, Stack, TextareaAutosize } from "@mui/material";
import { ContentPasteOutlined } from "@mui/icons-material";
export type ModalPasteRawNamingRulesElementProps = {
  onClose?: () => void;
  onConfirm: (text: string) => void;
  clipboardText: string;
};
export type ModalPasteRawNamingRulesProps = CommonModalProps<ModalPasteRawNamingRulesElementProps>;

const ModalPasteRawNamingRules = React.forwardRef<any, ModalPasteRawNamingRulesProps>((props, ref) => {
  const { closeModal, onClose, onConfirm, clipboardText, ...modalProps } = props;
  const [value, setValue] = useState(clipboardText);
  const { t } = useTranslation();

  const handleCancelClick = () => {
    onClose && onClose();
    closeModal();
  };

  const handleConfirmClick = () => {
    onConfirm(value);
    closeModal();
  };

  const handlePasteClick = () => {
    navigator.clipboard.readText().then((text) => setValue(text));
  };

  return (
    <Modal
      {...modalProps}
      title={t("modal:title.editNamingRule")}
      reference={ref}
      closeModal={handleCancelClick}
      width={720}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Stack direction="row" spacing={1}>
            <Button color="info" onClick={handlePasteClick} startIcon={<ContentPasteOutlined />}>
              {t("button:pasteClipboard")}
            </Button>
            <Button color="success" variant="outlined" onClick={handleConfirmClick}>
              {t("common:confirm")}
            </Button>
          </Stack>
        </Stack>
      }
    >
      <TextareaAutosize onChange={(e) => setValue(e.target.value)} value={value} />
    </Modal>
  );
});
export default ModalPasteRawNamingRules;
